<template>
  <div class="container">
    <div
   
      :class="{
        'selected-container disabled': disabled
      }"
      :style="customStyle"
      
      @mouseenter="showDelete = true"
      @mouseleave="showDelete = false"
    >
      
     
    <div
      class="selected-container"
      @click="onShowList"
    >
       <div
        class="image-container"
        :style="'background-color: ' + (selectedItem ? selectedItem.avatarColor :    '#008629')"
      >
        <img     :src="imgUrl" alt="image" :class="type === 'group' ? 'image group' : 'image person'" />
      </div>
      <span v-if="isUser" class="text">{{ selectedItem ? selectedItem.fullName || selectedItem.name : 'Choose' }}</span>
      <span v-if="selectedgroup" class="text">{{ selectedgroup ? selectedgroup.name || selectedgroup.name : 'Choose' }}</span>
    
      <span v-if="noSelected" class="text active">{{ selectedItem ? selectedItem.fullName || selectedItem.name : 'Choose' }}</span>
      <span v-if="noassigned" class="text">  Route to everyone </span>
         
      
      
      
      
      <img v-if="!disabled" src="@/assets/images/dropdown.svg" class="dropdown-img" alt="dropdown" />
    
      </div>



    

    
  
    </div>
 

    <div >
       <div v-if="showList " class = "list display">
        <div class="list-item" @mouseover="displayUser = true" @mouseleave="displayUser = false">
       <call-flow-button-icon :action="ACTION_TYPES.ACTION_PERSON" />
       <span class="item-name">Route to a person</span>
       <img src="@/assets/images/next.svg" alt="next" />
     <div   v-if = "displayUser" class="list more">
   <div v-for="(item, index) in data" :key="index" class="list-item" @click="onClickItem(item)">
     <div
       class="item-avatar"
       :class="{
         'item-avatar group': type === 'group'
       }"
       :style="'background-color: ' + item.avatarColor"
     >
       {{ item.avatarName }}
     </div>
     <div class="item-name">
       {{ item.fullName || item.name }}
     </div>
   </div>
 </div>

       

 </div>


 <div class="list-item" @mouseover="hoverGroup = true" @mouseleave="hoverGroup = false">
       <call-flow-button-icon :action="ACTION_TYPES.ACTION_GROUP" />
       <span class="item-name">Route to group</span>
       <img src="@/assets/images/next.svg" alt="next" />

       <div v-if="hoverGroup" class="list more">
         <div
           v-for="(group, index) in groups"
           :key="index"
           class="list-item"
           @click="onClickItemNoUser( group)"
         >
           <div class="item-avatar" :style="'background-color: ' + group.avatarColor">
             {{ group.avatarName.charAt(0).toUpperCase() }}
           </div>
           <div class="item-name">
             {{ group.name }}
           </div>
         </div>
       </div>
     </div>
      <div class="list-item"    @click="noAssign" >
       <call-flow-button-icon :action="ACTION_TYPES.ACTION_PERSON" />
       <span class="item-name">Route to everyone</span>
     
     

       

 </div>
    <div v-if="!noSelected" class="list-item" @click="onDele">
            <div
              class="item-avatar"
              
              
            >
            <img
          
            src="@/assets/images/delete.svg"
            class="delete-img"
        
               @mouseenter="noDisplay = true"
          @mouseleave="noDisplay = false"
            alt="delete"
          />
   
          
            </div>
            <div class="item-name">
              Delete route
            </div>
        
        
            
            
          </div>
     


  </div>
 
    </div>
    

   
      <div   v-if="false">
        <div v-if="showList && selectedItem" class="list">
          <div v-for="(item, index) in data" :key="index" class="list-item" @click="onClickItem(item)">
            <div
              class="item-avatar"
              :class="{
                'item-avatar group': type === 'group'
              }"
              :style="'background-color: ' + item.avatarColor"
            >
              {{ item.avatarName }}
            </div>
            <div class="item-name">
              {{ item.fullName || item.name }}
            </div>
        
        
            
            
          </div>
     
      
          <div class="list-item" @click="onDele">
            <div
              class="item-avatar"
              
              
            >
            <img
          
            src="@/assets/images/delete.svg"
            class="delete-img"
        
               @mouseenter="noDisplay = true"
          @mouseleave="noDisplay = false"
            alt="delete"
          />
   
          
            </div>
            <div class="item-name">
              Delete route
            </div>
        
        
            
            
          </div>
     
    
           
        </div>
    
    <div v-if="showList && !selectedItem" class="list">
   
         <div class="list-item" @click="onDele">
            <div
              class="item-avatar"
              
              
            >
            <img
          
            src="@/assets/images/delete.svg"
            class="delete-img"
        
               @mouseenter="noDisplay = true"
          @mouseleave="noDisplay = false"
            alt="delete"
          />
   
          
            </div>
            <div class="item-name">
              Delete route
            </div>
        
        
            
            
          </div>
    



            </div>
        
        
        
        
      </div>
     
   
    

  </div>
</template>
 
<script>



 import { ROUTE_TYPES, ACTION_TYPES } from '@/constants';

  import CallFlowButtonIcon from './CallFlowButtonIcon';


export default {
  name: 'CallFlowDropdown',
  props: {
    type: String,
    customStyle: String,
    data: Array,
    onSelect: Function,
    groups: Array ,
    selectedItem: Object,
    isClicked : String,
    isContacts: String,
     itemTexts: String,
     selectedgroup   : Object
  },
  data() {
    return {
      showList: false,
      disabled: false,
      isText: false,
      showDelete: false,
      ACTION_TYPES,
      noDisplay: false,
         hover: false,
    hoverRecord: false,
    hoverNumbers: false,
  
    hoverPerson: false,
    hoverGroup: false,
    displayUser: false
    };
  },
   components: { CallFlowButtonIcon },
   computed: {
    imgUrl() {
      const images = require.context('@/assets/images', false, /\.svg$/);
      return images('./' +     (this.noSelected ? "person"   :   this.type) + '_white.svg');
    },
    isUser()
    {
    

      if(this.type == "person")
      {
        return true;
      }    
      else
      {
        return false;
      }



    },
    noSelected ()
    {
    
      if(this.type == "")
      {
          return   true;         
      }
      else
      {
        return false;
      }


    },
     onText ()
     {
    
      return false
     },
     noassigned () 
     {
       if(this.type == "noassign")
       {
        return true;
      }    
      else
      {
        return false;
      }



     }
  },
  mounted() {
   
    if (this.data.length === 1) {
      this.onSelect(this.data[0]);
      this.disabled = true;
    }
  },
  methods: {
    onShowList() {
                                              
            this.showList = !this.showList;
                                console.log(this.showList)
  
  
    },
    onClickItem(item) {
      this.showList = false;
      this.onSelect(item);
      console.log("ss")

        this.$emit('setsTypes', "person" );
    },
    onSuccessed ()    {
       console.log("s")

    },
     onClickItemNoUser(item) {
      this.showList = false;
           this.$emit('setsgroup', item );
      console.log("ss")
     
        this.$emit('setsTypes', "group" );
    },
  
    noAssign() {
      this.showList = false;
             this.$emit('setsgroup',          null );
             this.onSelect(null)
        this.$emit('setsTypes', "noassign" );
    },
  
    onDele()
    {
       this.onSelect(null)
       this.$emit('setsgroup', null  );
      this.displayUser = false;
      this.hoverGroup =  false;
      this.$emit('setsTypes',   "" );
       this.showList = false;
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
}

  .selected-container {
  width: 320px;
  height: 85px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 26px 0 10px;
  cursor: pointer;
  &.disabled {
    cursor: unset;
  }
  .isText
  {
    display: "flex"
  }
  
   .active {
    color: #008629  !important;
  
  }
 
  .noassign
  {
      background-color:   #008629 !important;
  }
 
 
 
 
  .image-container {
    width: 65px;
    height: 65px;
    background: $colorPlaceholder;
    box-shadow: 0px 0px 2px rgba(78, 78, 78, 0.4);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .image {
      &.group {
        width: 54px;
        height: 35px;
      }
      &.person {
        width: 40px;
        height: 40px;
        margin-top: 3px;
      }
    }
  }

  .text {
    flex: 1;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: $colorText;
    margin-left: 25px;
  }

  .dropdown-img {
    width: 16px;
    height: 10px;
  }
}

.list {
  position: absolute;
  left: 105px;
  top: 85px;
  width: 225px;
  max-height: 197px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(83, 95, 119, 0.15), 0px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 8px;
  padding: 10px 0;
  overflow: auto;
  z-index: 9999;
  &.more {
        left: 210px;
        top: 0;
        bottom: unset;
        max-height: 250px;
        overflow: auto;
      }
      &.display
          {
             overflow: visible;
          }
  .list-item {
    width: 100%;
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 12px 15px;
    &:hover {
      background-color: $colorBack;
    }

    .item-avatar {
      width: 20px;
      height: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      letter-spacing: 0.03em;
      color: #ffffff;

      &.group {
        border-radius: 5px;
      }
    }

    .item-name {
      flex: 1;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.01em;
      margin-left: 15px;
      color: $colorText;
    }
  }
}
  .delete-img {
      width: 20px;
      height: 20px;
   }
 
</style>
